import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { v4 as uuid } from 'uuid'
import { IconPlus, IconX, IconCheck } from '@tabler/icons-react'

import { editScorecardConfig } from '@/reducers/qa-copilot/qa-copilot.redux'
import { Button } from '@/components/buttons/Button'
import { TextInput } from '@/components/forms/TextInput'

export const QACopilotSidebarInlineEntry = ({ label }) => {
  const dispatch = useDispatch()
  const { scorecardConfig } = useSelector((state) => state.qaCopilot)
  const [inlineEntry, setInlineEntry] = useState({ editing: false, value: '' })

  const handleCreateInlineEntry = () => {
    setInlineEntry({ editing: true, value: '' })
  }

  const handleCancelInlineEntry = () => {
    setInlineEntry({ editing: false, value: '' })
  }

  const handleUpdateInlineEntry = (event) => {
    setInlineEntry({ editing: true, value: event.target.value })
  }

  const handleSubmitInlineEntry = (event) => {
    event.preventDefault()

    const updatedScorecardConfig = {
      ...scorecardConfig,
      sections: [
        ...scorecardConfig.sections,
        {
          ssid: uuid(),
          name: inlineEntry.value,
          measures: [{ name: `${inlineEntry.value} Measure`, criteria: [] }],
          order_id: scorecardConfig.sections.length,
        },
      ],
    }

    dispatch(editScorecardConfig(updatedScorecardConfig))

    setInlineEntry({ editing: false, value: '' })
  }

  return (
    <div className="qa-copilot-sidebar__inline-entry">
      {!inlineEntry.editing ? (
        <Button small onClick={handleCreateInlineEntry}>
          <IconPlus />
          {label}
        </Button>
      ) : (
        <form className="vertical-center small-gap" onSubmit={handleSubmitInlineEntry}>
          <TextInput
            small
            autoFocus
            type="text"
            value={inlineEntry.value}
            onChange={handleUpdateInlineEntry}
            className="full-width"
            placeholder="Enter a name"
            style={{ maxWidth: '160px' }}
          />
          <div className="vertical-center small-gap">
            <Button small square onClick={handleCancelInlineEntry}>
              <IconX />
            </Button>
            <Button small square type="submit" brand disabled={!inlineEntry.value}>
              <IconCheck />
            </Button>
          </div>
        </form>
      )}
    </div>
  )
}
